import _ from 'lodash';

export const state = () => ({
  selections: [],
  stake: 10,
  eventId: null,
  lastUsedStake: null,
  processingStatus: null,
  error: null,
  warning: null,
  visible: false,
  updatedAt: null,
  ticket: null,
  receipt: null,
  precannedId: null,
  precannedLoading: false,
})

export const mutations = {
  toggleBetslip(state, visible = null) {
    console.log('toggleBetslip', visible)
    if(_.isNull(visible))
      state.visible = !this.state.visible;
    else
      state.visible = visible;
  },
  setPrecannedLoading(state, receipt) {
    state.precannedLoading = receipt;
  },
  setReceipt(state, receipt) {
    state.receipt = receipt;
  }, 
  setError(state, error) {
    state.error = error;
  },  
  setWarning(state, warning) {
    state.warning = warning;
  },
  setLastUpdate(state) {
    state.updatedAt = new Date();;
  },
  setBetType(state, betType) {
    state.betType = betType;
  },
  setLastUsedStake(state, value) {
    state.lastUsedStake = value;
  },
  setStake(state, value) {
    state.stake = value;
  },
  setTicket(state, value) {
    state.ticket = value;
  },
  setSelections(state, value) {
    state.selections = value;
  },
  setProcessingStatus(state, value) {
    state.processingStatus = value;
  },
  setEvent(state, eventId) {
    state.eventId = eventId;
  },
  setPrecannedId(state, precannedId) {
    state.precannedId = precannedId;
  },
  add(state, item) {
    console.log('add', item);
    state.selections.push(item)
    state.updatedAt = new Date();
  },
  remove(state, item) {
    state.selections = _.reject(state.selections, function(selection) {
      console.log('remove', selection, item)
      return  _.get(selection, 'id') === item;
    });
    state.updatedAt = new Date();
  },
  removeMarket(state, market_id) {
    state.selections = _.reject(state.selections, function(selection) {
      return  _.get(selection, 'market_id') == market_id;
    });
  },
  clear(state) {
    state.selections = []
  }
}